import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { KakaotalkTemplateCategoryComponent } from './kakaotalk-template/kakaotalk-template-category/kakaotalk-template-category.component';
import { KakaotalkTemplateLanguagesComponent } from './kakaotalk-template/kakaotalk-template-languages/kakaotalk-template-languages.component';
import { KakaotalkTemplateMediaHeaderComponent } from './kakaotalk-template/kakaotalk-template-languages/kakaotalk-template-media-header/kakaotalk-template-media-header.component';
import { KakaotalkTemplateMainComponent } from './kakaotalk-template/kakaotalk-template-main/kakaotalk-template-main.component';
import { KakaotalkTemplateComponent } from './kakaotalk-template/kakaotalk-template.component';
import { KakaotalkTemplatesComponent } from './kakaotalk-templates.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    KakaotalkTemplatesComponent,
    KakaotalkTemplateComponent,
    KakaotalkTemplateMainComponent,
    KakaotalkTemplateCategoryComponent,
    KakaotalkTemplateLanguagesComponent,
    KakaotalkTemplateMediaHeaderComponent,
  ],
  exports: [KakaotalkTemplatesComponent],
})
export class KakaotalkTemplatesModule {}
